import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { Menu, X } from "lucide-react";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/#apps", label: "Apps" },
  { to: "/#readiness", label: "Readiness" },
  { to: "/#capabilities", label: "Platform" },
  { to: "/#join-network", label: "Join Network" },
  { to: "/#request-demo", label: "Demo" },
  { to: "/#pricing", label: "Pricing" },
  { to: "/#contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        scrolled ? "backdrop-blur-xl bg-[#0a0a0b]/75 border-b border-white/5" : "bg-transparent"
      }`}
      data-testid="main-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="block" data-testid="nav-home-link">
          <Logo variant="aiv" />
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {NAV.map((n) => (
            <a
              key={n.label}
              href={n.to}
              className="font-mono-apex text-[11px] uppercase tracking-[0.2em] text-zinc-400 hover:text-white transition-colors"
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {n.label}
            </a>
          ))}
        </div>

        {/* Right side intentionally empty — login is admin-only via direct /login URL */}
        <div className="hidden md:block w-[1px]" />

        <button
          className="md:hidden text-white p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/5 bg-[#0a0a0b]/95 backdrop-blur-xl">
          <div className="px-6 py-4 flex flex-col gap-3">
            {NAV.map((n) => (
              <a
                key={n.label}
                href={n.to}
                onClick={() => setOpen(false)}
                className="font-mono-apex text-xs uppercase tracking-[0.2em] text-zinc-400 hover:text-white py-2"
              >
                {n.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}
